<script setup lang="ts">
defineProps<{
  color?: any
}>()
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 35"
    :style="color"
    class="eb-icon-nosize w-10 h-10 p-1"
  >
    <g>
      <path
        d="M11.159,33.807C2.153,30.305-2.307,20.166,1.193,11.158C4.696,2.152,14.837-2.309,23.841,1.195
	c9.006,3.5,13.466,13.643,9.966,22.646C30.304,32.848,20.163,37.307,11.159,33.807"
      />
      <path
        fill="#FFFFFF"
        d="M22.414,21.211l-4.88-3.711l-4.783,3.709c-0.399,0.307-0.633,0.783-0.632,1.286v2.049h10.941v-2.037
		C23.058,21.998,22.819,21.52,22.414,21.211z"
      />
      <path
        fill="#FFFFFF"
        d="M10.768,6.499h13.464c0.051,0,0.091,0.041,0.091,0.091v2.402c0,0.051-0.041,0.091-0.091,0.091H10.768
		c-0.051,0-0.091-0.041-0.091-0.091V6.59C10.677,6.54,10.718,6.499,10.768,6.499z"
      />
      <path
        fill="#FFFFFF"
        d="M10.768,25.916h13.464c0.051,0,0.091,0.041,0.091,0.091v2.402c0,0.05-0.041,0.091-0.091,0.091H10.768
		c-0.051,0-0.091-0.041-0.091-0.091v-2.402C10.677,25.957,10.718,25.916,10.768,25.916z"
      />
      <path
        fill="#FFFFFF"
        d="M12.06,12.328c0,0.495,0.226,0.963,0.614,1.271l4.856,3.882l4.857-3.882
		c0.388-0.308,0.614-0.776,0.614-1.271v-1.882H12.06V12.328z"
      />
    </g>
  </svg>
</template>
